import type { QuizBank } from '../engines/QuizEngine';

// Para agregar preguntas: súmalas al banco que corresponda. Para agregar un
// banco nuevo: agrega otro objeto al array — el engine lo incluye en la
// rotación automáticamente. Cada ronda toma 5 preguntas al azar del banco.
export const QUIZ_BANKS: QuizBank[] = [
	{
		id: 'fiscal_basico',
		title: 'Quiz fiscal',
		emoji: '⚡',
		questions: [
			{
				question: '¿Qué significa SAT?',
				options: [
					'Servicio de Administración Tributaria',
					'Sistema de Ahorro Total',
					'Secretaría de Asuntos Técnicos',
				],
				correctOption: 'Servicio de Administración Tributaria',
				funFact:
					'Es la institución que administra los impuestos en México. La misma con la que estamos conectando tu cuenta ahora mismo.',
			},
			{
				question: '¿Cuál de estos gastos puedes deducir en tu anual?',
				options: [
					'Lentes graduados',
					'Tacos de la esquina',
					'Suscripción de streaming',
				],
				correctOption: 'Lentes graduados',
				funFact:
					'Los lentes graduados, consultas médicas y colegiaturas son deducibles si pides factura. ¡Los tacos todavía no! 🌮',
			},
			{
				question: 'Si tienes saldo a favor en tu declaración anual, el SAT…',
				options: [
					'Te deposita el dinero en tu cuenta',
					'Se lo queda para siempre',
					'Te manda un diploma',
				],
				correctOption: 'Te deposita el dinero en tu cuenta',
				funFact:
					'Sí, el SAT devuelve dinero. Miles de personas reciben su saldo a favor cada año después de declarar.',
			},
			{
				question:
					'¿En qué mes presentan su declaración anual las personas físicas?',
				options: ['Abril', 'Enero', 'Diciembre'],
				correctOption: 'Abril',
				funFact:
					'Abril es el mes de la anual para personas físicas. Con tu SAT conectado, heru la prepara por ti.',
			},
			{
				question: '¿Qué es el RFC?',
				options: [
					'Tu clave única como contribuyente',
					'Una estación de radio fiscal',
					'Un trámite opcional',
				],
				correctOption: 'Tu clave única como contribuyente',
				funFact:
					'El Registro Federal de Contribuyentes te identifica ante el SAT, como una CURP pero para impuestos.',
			},
			{
				question: 'Una factura CFDI es…',
				options: [
					'Un comprobante fiscal digital',
					'Un cupón de descuento',
					'Una multa del SAT',
				],
				correctOption: 'Un comprobante fiscal digital',
				funFact:
					'CFDI significa Comprobante Fiscal Digital por Internet. Cada factura que pides puede bajar tus impuestos.',
			},
			{
				question: 'Si trabajas en apps como Uber o Rappi, la plataforma…',
				options: [
					'Te retiene impuestos cada mes',
					'Paga todos tus impuestos por ti',
					'No tiene nada que ver con el SAT',
				],
				correctOption: 'Te retiene impuestos cada mes',
				funFact:
					'Las plataformas retienen una parte de tus ingresos. Declarar te ayuda a recuperar lo que pagaste de más.',
			},
			{
				question: 'La contraseña del SAT (antes CIEC) sirve para…',
				options: [
					'Consultar tu información fiscal en línea',
					'Entrar a tu banca móvil',
					'Pedir un préstamo',
				],
				correctOption: 'Consultar tu información fiscal en línea',
				funFact:
					'Es justo la que usamos para conectar tu cuenta: solo permite consultar tu información, no hacer movimientos.',
			},
			{
				question: '¿Cuántas veces puedes intentar conectar tu SAT con heru?',
				options: [
					'Las que necesites, sin bloqueos',
					'Solo 3 intentos',
					'Una por año',
				],
				correctOption: 'Las que necesites, sin bloqueos',
				funFact:
					'No hay límite ni bloqueos por intentos fallidos. Puedes intentarlo las veces que haga falta.',
			},
			{
				question: 'Declarar a tiempo te ayuda a…',
				options: [
					'Evitar multas y recargos',
					'Absolutamente nada',
					'Subir de nivel en el SAT',
				],
				correctOption: 'Evitar multas y recargos',
				funFact:
					'Las multas y recargos crecen mes con mes. Ponerte al corriente siempre es más barato hoy que mañana.',
			},
		],
	},
	{
		id: 'deducciones',
		title: '¿Se puede deducir?',
		emoji: '🧾',
		questions: [
			{
				question: 'Consultas con el psicólogo',
				options: ['Sí, con factura', 'No, nunca'],
				correctOption: 'Sí, con factura',
				funFact:
					'La terapia es gasto médico deducible. Pide factura y paga con tarjeta o transferencia, no en efectivo.',
			},
			{
				question: 'El gimnasio',
				options: ['No es deducible', 'Sí, es gasto de salud'],
				correctOption: 'No es deducible',
				funFact:
					'Aunque sea por salud, el gym no entra en las deducciones personales. Las consultas médicas sí.',
			},
			{
				question: 'Colegiaturas de tus hijos',
				options: ['Sí, con tope por nivel escolar', 'No, la educación no deduce'],
				correctOption: 'Sí, con tope por nivel escolar',
				funFact:
					'De preescolar a prepa son deducibles con un tope por nivel. La universidad no entra.',
			},
			{
				question: 'Medicinas compradas en la farmacia',
				options: [
					'Solo si vienen en una factura de hospital',
					'Sí, con el ticket de compra',
				],
				correctOption: 'Solo si vienen en una factura de hospital',
				funFact:
					'Las medicinas sueltas no deducen; solo cuando forman parte de una factura hospitalaria.',
			},
			{
				question: 'Los intereses de tu crédito hipotecario',
				options: ['Sí, son deducción personal', 'No, los créditos no deducen'],
				correctOption: 'Sí, son deducción personal',
				funFact:
					'Los intereses reales de tu hipoteca son deducibles — el banco te entrega la constancia cada año.',
			},
			{
				question: 'El dentista',
				options: ['Sí, con factura y pago con tarjeta', 'No, solo el médico general'],
				correctOption: 'Sí, con factura y pago con tarjeta',
				funFact:
					'Dentista, oftalmólogo, nutriólogo y psicólogo cuentan como gastos médicos deducibles.',
			},
			{
				question: 'Gastos funerarios de un familiar directo',
				options: ['Sí, hasta un tope anual', 'No, jamás'],
				correctOption: 'Sí, hasta un tope anual',
				funFact:
					'Los gastos funerarios de tu familia directa son deducibles hasta un tope anual. Pide factura.',
			},
			{
				question: 'Aportaciones extra para tu retiro',
				options: ['Sí, con límites', 'No, el ahorro no deduce'],
				correctOption: 'Sí, con límites',
				funFact:
					'Las aportaciones voluntarias a tu Afore o a planes personales de retiro bajan tu impuesto anual.',
			},
		],
	},
	{
		id: 'mitos',
		title: '¿Mito o realidad?',
		emoji: '🔮',
		questions: [
			{
				question: '"Si gano poco, no tengo que declarar"',
				options: ['Mito', 'Realidad'],
				correctOption: 'Mito',
				funFact:
					'Si estás dado de alta con obligaciones, declaras aunque sea en ceros. Declarar en ceros también cuenta.',
			},
			{
				question: '"El SAT te puede devolver dinero"',
				options: ['Realidad', 'Mito'],
				correctOption: 'Realidad',
				funFact:
					'El saldo a favor existe: si te retuvieron de más durante el año, lo recuperas declarando.',
			},
			{
				question: '"Facturar es solo para empresas grandes"',
				options: ['Mito', 'Realidad'],
				correctOption: 'Mito',
				funFact:
					'Cualquier persona con RFC puede facturar — freelancers y repartidores incluidos.',
			},
			{
				question: '"Si ya me atrasé, ya no hay forma de arreglarlo"',
				options: ['Mito', 'Realidad'],
				correctOption: 'Mito',
				funFact:
					'Siempre puedes ponerte al corriente. Entre antes lo hagas, menores los recargos.',
			},
			{
				question: '"El SAT ve mis facturas casi en tiempo real"',
				options: ['Realidad', 'Mito'],
				correctOption: 'Realidad',
				funFact:
					'Cada CFDI queda registrado al instante — por eso heru puede leer tu información al conectarte.',
			},
			{
				question: '"Pedir factura no sirve de nada"',
				options: ['Mito', 'Realidad'],
				correctOption: 'Mito',
				funFact:
					'Cada factura de un gasto deducible baja tu impuesto anual. Pedirla es dinero a tu favor.',
			},
			{
				question: '"Necesito ir con un contador presencial para declarar"',
				options: ['Mito', 'Realidad'],
				correctOption: 'Mito',
				funFact:
					'Con tu SAT conectado, heru prepara y presenta tus declaraciones 100% en línea.',
			},
			{
				question: '"Las apps como Uber o Didi ya me retienen impuestos"',
				options: ['Realidad', 'Mito'],
				correctOption: 'Realidad',
				funFact:
					'Las plataformas retienen cada mes. Declarar te permite ajustar cuentas y a veces recuperar dinero.',
			},
		],
	},
];
